import React, { useCallback } from 'react';
import styles from 'features/profile/index.module.scss';
import Button from 'componets/button';
import { LockIcon } from 'icons';
import {
  CHANGE_CONFIRM_NEW_PASSWORD,
  CHANGE_NEW_PASSWORD,
  CHANGE_OLD_PASSWORD,
  useChangePassword,
  useChangePasswordContext,
} from 'features/profile/use-change-password';
import { CHANGE_PASSWORD_EDIT_MODE } from 'features/profile/use-profile';
import UpdatePassword from 'modules/update-password';
import analytics from 'service/analytics';

const ProfileChangePassword = React.forwardRef(({ inEditMode, onOpenEditMode, onCloseEditMode }, ref) => {
  const { state, dispatch, changePassword } = useChangePassword(onCloseEditMode);

  const changeOldPassword = useCallback(
    value =>
      dispatch({
        type: CHANGE_OLD_PASSWORD,
        payload: value,
      }),
    [dispatch]
  );

  const changeNewPassword = useCallback(
    value =>
      dispatch({
        type: CHANGE_NEW_PASSWORD,
        payload: value,
      }),
    [dispatch]
  );

  const changeConfirmNewPassword = useCallback(
    value =>
      dispatch({
        type: CHANGE_CONFIRM_NEW_PASSWORD,
        payload: value,
      }),
    [dispatch]
  );

  const onChangePasswordClick = () => {
    analytics.track('帳號資訊頁_帳號_變更密碼_送出_click');
    changePassword();
  };

  const ChangePassword = () => {
    if (inEditMode) {
      return (
        <div className={`${styles.box} ${styles.inEditMode} ${styles.mobileEditState}`} ref={ref}>
          <div className={`${styles.boxInfo}`}>
            <div className={styles.boxTitle}>變更密碼</div>
            <UpdatePassword
              oldPassword={state.oldPassword}
              oldPasswordErrorMessage={state.oldPasswordError}
              onChangeOldPassword={changeOldPassword}
              newPassword={state.newPassword}
              newPasswordErrorMessage={state.newPasswordError}
              onChangeNewPassword={changeNewPassword}
              confirmedPassword={state.confirmNewPassword}
              confirmedPasswordErrorMessage={state.confirmNewPasswordError}
              onChangeConfirmedPassword={changeConfirmNewPassword}
              onOldPasswordFocus={() => analytics.track('帳號資訊頁_帳號_變更密碼_輸入原密碼_click')}
              onNewPasswordFocus={() => analytics.track('帳號資訊頁_帳號_變更密碼_輸入新密碼_click')}
              onConfirmedPasswordFocus={() => analytics.track('帳號資訊頁_帳號_變更密碼_再次確認新密碼_click')}
              onUpdatePassword={onChangePasswordClick}
            />
            <div className={styles.boxButton}>
              <Button
                variant="text"
                onClick={() => {
                  analytics.track('帳號資訊頁_帳號_變更密碼_取消_click');
                  onCloseEditMode();
                }}
              >
                取消
              </Button>
              <Button loading={state.loading} onClick={onChangePasswordClick}>
                儲存
              </Button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={`${styles.box} ${styles.fullClick}`}
          onClick={() => {
            analytics.track('帳號資訊頁_帳號_變更密碼_click');
            onOpenEditMode(CHANGE_PASSWORD_EDIT_MODE);
          }}
        >
          <div className={styles.boxInfo}>
            <div className={styles.boxTitle}>
              <LockIcon />
              變更密碼
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <useChangePasswordContext.Provider>
      <ChangePassword />
    </useChangePasswordContext.Provider>
  );
});

export default ProfileChangePassword;
